// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__sLVFv","image":"Hero_image__uqq6a"};